import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackLead } from '../lib/metaPixel';
import { trackAppointmentScheduled } from '../lib/openaiPixel';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Lead con guard de sesión: NO se duplica si ya se registró al agendar en /agenda
    trackLead();
    // Conversión OpenAI en página de confirmación: dedup vía localStorage,
    // si ya se registró desde el widget de Calendly o en una recarga previa, NO se envía de nuevo
    trackAppointmentScheduled();
  }, []);

  useEffect(() => {
    // Load Google Tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17859858354';
    document.head.appendChild(gtagScript);

    const gtagInlineScript = document.createElement('script');
    gtagInlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17859858354');
    `;
    document.head.appendChild(gtagInlineScript);

    // Wait for gtag to be available, then fire conversion event
    const conversionScript = document.createElement('script');
    conversionScript.innerHTML = `
      (function checkGtag() {
        if (typeof gtag !== 'undefined') {
          gtag('event', 'conversion', {
            'send_to': 'AW-17859949825/P4kdCPrz_f4bEIHqpMRC',
            'value': 1500.0,
            'currency': 'MXN'
          });
        } else {
          setTimeout(checkGtag, 100);
        }
      })();
    `;
    document.head.appendChild(conversionScript);

    return () => {
      // Clean up scripts on unmount
      if (gtagScript.parentNode) {
        gtagScript.parentNode.removeChild(gtagScript);
      }
      if (gtagInlineScript.parentNode) {
        gtagInlineScript.parentNode.removeChild(gtagInlineScript);
      }
      if (conversionScript.parentNode) {
        conversionScript.parentNode.removeChild(conversionScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-lg shadow-2xl p-12 md:p-16">
          <h1 className="text-4xl md:text-5xl font-light text-neutral-900 mb-8 tracking-tight">
            GRACIAS POR TU INFORMACIÓN
          </h1>
          <p className="text-xl md:text-2xl font-light text-neutral-600 mb-12">
            NUESTRO EQUIPO SE PONDRÁ EN CONTACTO
          </p>
          
          <div className="mb-8">
            <img
              src="/images/logo-cr-home.png"
              alt="CR Home"
              className="h-24 w-auto mx-auto object-contain"
            />
          </div>

          <button
            onClick={() => navigate('/')}
            className="inline-block mt-8 px-8 py-3 bg-amber-600 text-white font-light tracking-wide hover:bg-amber-700 transition-colors duration-300 rounded-sm"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;